
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';

const initialState:any = {
  apiEndPoint: "reports/order-material",
  data:{},
  error:null
};

const orderMaterialReports = createSlice({
  name: initialState.apiEndPoint,
  initialState,
  reducers: {
   
    // get Item details
    setData(state, action) {
      state.data = action.payload;
    },
    hasError(state, action) {
      state.error = action.payload.error;
    }
  }
});


export default orderMaterialReports.reducer;

function getApiEndPoint(){
  return store.getState().orderMaterialReports.apiEndPoint
}

export const { setData } = orderMaterialReports.actions;


export function getOrderMaterialReport() {
  return async () => {
    try {
      const response = await axios.get(getApiEndPoint());
      dispatch(orderMaterialReports.actions.setData(response.data));
    } catch (error) {
      dispatch(orderMaterialReports.actions.hasError(error));
    }
  };
}
